/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import groupSelectors from 'redux/reduxStore/group';
import navigationActions from 'redux/actions/navigation';

import GroupDeletedView from './GroupDeleted.view';
import routeNames from 'lib/routeNames';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    goHome: () => {
      navigationActions.goTo(routeNames.home())
    },
  };
}

class GroupDeletedPresenter extends React.Component {
  render() {
    return (
      <GroupDeletedView
        goHome={this.props.goHome}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDeletedPresenter);